import { createApi } from "@reduxjs/toolkit/query/react";
import { axiosBaseQuery } from "@src/service";
import { ZoneEntity } from '@src/core/features/zones/entites/zone-entity';
import type { SafeLandZoneEntity } from '@src/core/features/zones/entites/safe-land-zone-entity';
import { ZoneCoordinateEntity } from '@src/core/features/zones/entites';
import { ICheckAndPlanResponse } from "./types";

export const baseZonesApi = createApi({
  baseQuery: axiosBaseQuery(),
  reducerPath: 'baseZonesApi',
  tagTypes: ['GetZones', 'SafeLandZones'],
  endpoints: (builder) => ({
    getZones: builder.query<ZoneEntity[], void>({
      query: () => ({
        url: '/api/no-fly-zones',
        method: 'GET',
      }),
      providesTags: ['GetZones'],
    }),

    getSafeLandZones: builder.query<SafeLandZoneEntity[], void>({
      providesTags: ['SafeLandZones'],
      query: () => ({
        url: '/api/safe-land-zones',
        method: 'GET',
      }),
    }),

    checkAndPlan: builder.mutation<ZoneCoordinateEntity[], ICheckAndPlanResponse>({
      query: ({ path }) => ({
        url: '/api/no-fly-zones/check-and-plan-route',
        method: 'POST',
        data: path,
      })
    })
  })
});

export const { useGetZonesQuery, useGetSafeLandZonesQuery, useCheckAndPlanMutation } = baseZonesApi;